import React, { useCallback, useMemo } from 'react';
import { Option, RadioGroup } from 'src/@vymo/ui/atoms/radio';
import { FormContextProps } from '../formProvider/types';

type Props = {
  disabled: boolean;
  onChange: (arg0, arg1, arg2?) => void;
  value?: boolean;
  viewMode?: boolean;
  hint?: string;
};

const options = [
  { code: 'true', name: 'true' },
  { code: 'false', name: 'false' },
];
export default function BooleanAdapter({
  disabled = false,
  onChange,
  value,
  loading,
  hint,
  viewMode = false,
  ...field
}: Props & FormContextProps) {
  const radioValue = useMemo(() => {
    if (value === true) {
      return 'true';
    }
    if (value === false) {
      return 'false';
    }

    return undefined;
  }, [value]);

  const onChangeRadioValue = useCallback(
    (selectedValue, event) => {
      if (selectedValue?.[0]?.code === 'true') {
        onChange(true, event);
      } else {
        onChange(false, event);
      }
    },
    [onChange],
  );

  return (
    <RadioGroup
      {...field}
      name={String(hint)}
      type="chipRadio"
      onChange={onChangeRadioValue}
      value={radioValue}
      viewMode={viewMode}
    >
      {options?.map((option) => (
        <Option
          {...option}
          key={option.code}
          value={option.code}
          label={option.name}
          disabled={disabled}
        />
      ))}
    </RadioGroup>
  );
}
